import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

/**
 * Site-wide maintenance notice. Rendered only when the CX-ADR-019
 * `maintenanceBanner.enabled` flag is `true` (see the `CovFeatureGate` in
 * `App.tsx`). Kept flag-agnostic so the gate owns the visibility decision.
 */
export const MaintenanceBanner = () => {
  const { t } = useTranslation();

  return (
    <Box
      role="status"
      sx={{
        width: "100%",
        padding: "var(--spacing12, 12px) var(--spacing24, 24px)",
        backgroundColor: "var(--global-warning-100, #fff4e5)",
        color: "var(--global-neutral-900, #1a1a1a)",
        textAlign: "center",
      }}
    >
      <Typography
        sx={{
          fontSize: "var(--body-b3-12-regular-size, 12px)",
          lineHeight: "var(--body-b3-12-regular-line-height, 18px)",
        }}
      >
        {t(
          "maintenance.banner",
          "Scheduled maintenance is in progress. Some features may be temporarily unavailable.",
        )}
      </Typography>
    </Box>
  );
};
